/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { getClientCellProps as p, isClientReference as C } from "../../utils/index.mjs";
import { GridHierarchyCellServerContainer as c } from "./GridHierarchyCellServerContainer.mjs";
import { getHierarchyCellTdProps as a, getCustomCell as u } from "./utils.mjs";
const g = (s) => {
  const { cellProps: e } = s, l = p(e), { tdProps: r, content: n } = a(e), o = u(e);
  if (o) {
    const m = C(o);
    return /* @__PURE__ */ t.createElement(
      c,
      {
        cellProps: l,
        tdProps: r,
        isCustom: !0,
        isClient: m
      },
      /* @__PURE__ */ t.createElement(o, { ...l, tdProps: r }, n)
    );
  }
  const i = e.rowType !== "groupHeader" ? /* @__PURE__ */ t.createElement("td", { ...r }, n) : null;
  return /* @__PURE__ */ t.createElement(c, { cellProps: l, tdProps: r }, i);
};
export {
  g as GridHierarchyCellServer
};
